import axios from 'axios'
import appConfig from '@/appconfig'
import store from '../store'
import constant from '@constants/constant'
import endpoint from '@constants/apipath'
import common from '@state/modules/common'
export const state = {
  cached: [],
  currentPage: 1,
  reports: [],
  selectedRow: {},
  getLatestReports: true,
}

export const getters = {
  getLatestReportsStatus: (state) => {
    return state.getLatestReports
  },
}

export const mutations = {
  CACHE_REPORT(state, selectedReports) {
    state.cached.push(selectedReports)
  },
  SET_ACTIVITYREPORT(state, activityReport) {
    state.activityReport = activityReport
  },
  SET_CONSENTREPORT(state, consentReport) {
    state.consentReport = consentReport
  },

  SET_CURRENT_PAGE(state, pageNumber) {
    state.currentPage = pageNumber
  },

  SET_REPORTS(state, reports) {
    state.reports = reports
  },

  SET_SELECTED_ROW(state, row) {
    state.selectedRow = row
  },

  SET_LATEST_REPORTS_STATUS(state, status) {
    state.getLatestReports = status
  },
}
export const actions = {
  init({ state, dispatch }) {
    setDefaultAuthHeaders(state)
  },
  addForUrl(key, value) {
    return value || value === 0 ? `&${key}=${value}` : ''
  },
  fetchCostForBorrowerReport({ commit, dispatch, getters }, params) {
    var url =
      appConfig.apiEndPoint +
      endpoint.reportApiPath.usageReportCostForBorrowerReport +
      '?PageSize=5000' +
      actions.addForUrl('PageNumber', params.pageNumber) +
      actions.addForUrl('OrderNumber', params.orderNo) +
      actions.addForUrl('FirstName', params.firstName) +
      actions.addForUrl('LastName', params.lastName) +
      actions.addForUrl('CustomerName', params.customer) +
      actions.addForUrl('SSN', params.ssn) +
      actions.addForUrl('OrderedBy', params.orderedBy) +
      actions.addForUrl('OrderedFor', params.orderedFor) +
      actions.addForUrl('Product', params.product) +
      actions.addForUrl('Status', params.status) +
      actions.addForUrl('Key', 'All') +
      actions.addForUrl('Value', '') +
      actions.addForUrl('SortBy', params.sortBy) +
      actions.addForUrl('SortDirection', params.sortDirection) +
      actions.addForUrl('FromDate', params.startTime) +
      actions.addForUrl('ToDate', params.endTime) +
      actions.addForUrl('TimeZone', params.timeZone) +
      actions.addForUrl('isBranch', params.isBranch) +
      actions.addForUrl('CostForBorrower', params.costToBorrower) +
      actions.addForUrl('CostForBusiness', params.costToBusiness)

    // url = 'https://apim-dev-cpss.azure-api.net/dev/report/report/getvolumereport?FromDate=03/01/2021&ToDate=03/31/2021&TimeZone=Eastern%20Standard%20Time&SelectedCustomer[0]=2&SelectedProduct[0]=22&isBranch=true'
    return axios
      .get(url, {
        responseType: 'arraybuffer',
        headers: setHeaders(),
      })
      .then((response) => {
        if (response && response.data) {
          let fromDate = common.getDatepart(params.startTime)
          let toDate = common.getDatepart(params.endTime)
          let reportName = `${constant.costForBorrowerReport}_${
            params.customer ? params.customer : ''
          }_${fromDate}_${toDate}.pdf`

          if (window.navigator && window.navigator.msSaveBlob) {
            var IECSV = response.data
            var fullTemplate = [IECSV]
            var blob1 = new Blob(fullTemplate, { type: 'application/pdf' })
            window.navigator.msSaveBlob(blob1, reportName)
          } else {
            let blob = new Blob([response.data], { type: 'application/pdf' })
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = reportName
            link.click()
          }
        }
        return null
      })
      .catch((error) => {
        if (error.Response && error.Response.status === 401) {
          alert(
            'Error generating Cost To Borrower Report. Please try again later'
          )
        } else {
          alert(error)
        }
        return null
      })
  },
  fetchUsageReports(
    { commit, dispatch, getters },
    {
      startTime,
      endTime,
      timeZone,
      pageSize,
      pageNumber,
      key,
      value,
      sortBy,
      sortDirection,
      isBranch,

      firstName,
      lastName,
      orderedBy,
      orderedFor,
      orderNo,
      customer,
      ssn,
      product,
      status,
      costToBorrower,
      costToBusiness,
      isAdvanceSearch,
    } = {}
  ) {
    var url = ''

    if (isAdvanceSearch) {
      url =
        appConfig.apiEndPoint +
        endpoint.reportApiPath.usageReportAdvancedSearch +
        '?PageSize=' +
        pageSize +
        actions.addForUrl('PageNumber', pageNumber) +
        actions.addForUrl('OrderNumber', orderNo) +
        actions.addForUrl('FirstName', firstName) +
        actions.addForUrl('LastName', lastName) +
        actions.addForUrl('CustomerName', customer) +
        actions.addForUrl('SSN', ssn) +
        actions.addForUrl('OrderBy', orderedBy) +
        actions.addForUrl('OrderFor', orderedFor) +
        actions.addForUrl('Product', encodeURIComponent(product)) +
        actions.addForUrl('Status', status) +
        actions.addForUrl('Key', 'All') +
        actions.addForUrl('Value', '') +
        actions.addForUrl('SortBy', sortBy) +
        actions.addForUrl('SortDirection', sortDirection) +
        actions.addForUrl('FromDate', startTime) +
        actions.addForUrl('ToDate', endTime) +
        actions.addForUrl('TimeZone', timeZone) +
        actions.addForUrl('isBranch', isBranch) +
        actions.addForUrl('CostForBorrower', costToBorrower) +
        actions.addForUrl('CostForBusiness', costToBusiness)
    } else {
      url =
        appConfig.apiEndPoint +
        endpoint.reportApiPath.usagereportget +
        '?PageSize=' +
        pageSize +
        actions.addForUrl('PageNumber', pageNumber) +
        actions.addForUrl('Key', key) +
        actions.addForUrl('Value', encodeURIComponent(value)) +
        actions.addForUrl('SortBy', sortBy) +
        actions.addForUrl('SortDirection', sortDirection) +
        actions.addForUrl('FromDate', startTime) +
        actions.addForUrl('ToDate', endTime) +
        actions.addForUrl('TimeZone', timeZone) +
        actions.addForUrl('isBranch', isBranch)
    }
    return axios
      .get(url, {
        headers: setHeaders(),
      })
      .then((response) => {
        const activityReport = response.data
        commit('SET_ACTIVITYREPORT', activityReport)

        return activityReport
      })
      .catch((error) => {
        if (error.Response && error.Response.status === 401) {
          commit('SET_ACTIVITYREPORT', null)
        }
        return null
      })
  },

  DownloadUsageReports(
    { commit, dispatch, getters },
    {
      startTime,
      endTime,
      timeZone,
      key,
      value,
      sortBy,
      sortDirection,
      isBranch,
    } = {}
  ) {
    var url =
      appConfig.apiEndPoint +
      endpoint.reportApiPath.downloadreport +
      '?Key=' +
      key +
      '&Value=' +
      value +
      '&isBranch=' +
      isBranch +
      '&SortBy=' +
      sortBy +
      '&SortDirection=' +
      sortDirection +
      '&FromDate=' +
      startTime +
      '&ToDate=' +
      endTime +
      '&TimeZone=' +
      timeZone
    return axios
      .get(url, {
        headers: setHeaders(),
      })
      .then((response) => {
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          var IECSV = common.fixUnicodeCharsCsv(response.data)
          var fullTemplate = [IECSV]
          var blob1 = new Blob(fullTemplate, { type: 'text/html' })
          window.navigator.msSaveOrOpenBlob(blob1, 'UsageReport.csv')
        } else {
          const url = window.URL.createObjectURL(
            new Blob([common.fixUnicodeCharsCsv(response.data)])
          )
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'UsageReport.csv') // or any other extension
          document.body.appendChild(link)
          link.click()
        }

        return response
      })
  },

  fetchTimeZones({ commit }) {
    const headers = {
      'Content-Type': 'application/json',
      Authorization: axios.defaults.headers.common.Authorization,
    }
    return axios
      .get(`${appConfig.apiEndPoint}master/gettimezones`, headers)
      .then((response) => {
        return response.data
      })
    // .catch(function (error) {
    //   alert(error)
    // })
  },
  fetchUserSettings({ commit }, { userId } = {}) {
    return axios
      .get(
        `${appConfig.apiEndPoint}app/getusersettings/` + userId,
        setHeaders()
      )
      .then((response) => {
        return response.data
      })
  },

  fetchConsentReports(
    { commit, dispatch, getters },
    {
      guidRecord,
      startTime,
      endTime,
      timeZone,
      pageSize,
      pageNumber,
      key,
      value,
      sortBy,
      sortDirection,
    } = {}
  ) {
    var url =
      appConfig.reportApiUri +
      'consumerconsentreport/getconsumerconsentreport/' +
      guidRecord +
      '/' +
      startTime +
      '/' +
      endTime +
      '/' +
      timeZone +
      '?PageSize=' +
      pageSize +
      '&PageNumber=' +
      pageNumber +
      '&Key=' +
      key +
      '&Value=' +
      value +
      `&SortBy=${sortBy}&SortDirection=${sortDirection}`

    return axios
      .get(url, {
        headers: setHeaders(),
      })
      .then((response) => {
        const consentReport = response.data
        commit('SET_CONSENTREPORT', consentReport)

        return consentReport
      })
      .catch((error) => {
        if (error.Response && error.Response.status === 401) {
          commit('SET_CONSENTREPORT', null)
        }
        return null
      })
  },
  downloadTotalActivityReport(
    { commit },
    {
      userId,
      fromDate,
      toDate,
      timeZone,
      pageSize,
      pageNumber,
      key,
      value,
    } = {}
  ) {
    return axios
      .get(
        `${
          appConfig.reportApiUri
        }consumercreditactivityreport/downloads/${userId}/${fromDate}/${toDate}/${timeZone}?PageSize=${pageSize}&PageNumber=${pageNumber}&key=${key}&value=${value}`,
        setHeaders()
      )
      .then((response) => {
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          var IECSV = '\r\n' + response.data
          var fullTemplate = [IECSV]
          var blob1 = new Blob(fullTemplate, { type: 'text/html' })
          window.navigator.msSaveOrOpenBlob(blob1, 'ConsumerActivityReport.csv')
        } else {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'ConsumerActivityReport.csv') // or any other extension
          document.body.appendChild(link)
          link.click()
        }

        return response
      })
    // .catch(function(error) {
    //   console.log(error)
    // })
  },
  // downloadTotalConsentReport(
  //   { commit },
  //   {
  //     userId,
  //     fromDate,
  //     toDate,
  //     timeZone,
  //     pageSize,
  //     pageNumber,
  //     key,
  //     value,
  //   } = {}
  // ) {
  //   return axios
  //     .get(
  //       `${appConfig.reportApiUri}consumerconsentreport/downloads/${userId}/${fromDate}/${toDate}/${timeZone}?PageSize=${pageSize}&PageNumber=${pageNumber}&key=${key}&value=${value}`,
  //       setHeaders()
  //     )
  //     .then((response) => {
  //       if (window.navigator && window.navigator.msSaveOrOpenBlob) {
  //         var IECSV = '\r\n' + response.data
  //         var fullTemplate = [IECSV]
  //         var blob1 = new Blob(fullTemplate, { type: 'text/html' })
  //         window.navigator.msSaveOrOpenBlob(blob1, 'ConsumerConsentReport.csv')
  //       } else {
  //         const url = window.URL.createObjectURL(new Blob([response.data]))
  //         const link = document.createElement('a')
  //         link.href = url
  //         link.setAttribute('download', 'ConsumerConsentReport.csv') // or any other extension
  //         document.body.appendChild(link)
  //         link.click()
  //       }

  //       return response
  //     })
  //   // .catch(function(error) {
  //   // //  console.log(error)
  //   // })
  // },
  // fetchTotalConsentReport(
  //   { commit, dispatch, getters },
  //   { guidRecord, startTime, endTime, timeZone, key, value }
  // ) {
  //   var url =
  //     appConfig.reportApiUri +
  //     'consumerconsentreport/getconsumerconsentreporttotalrecords/' +
  //     guidRecord +
  //     '/' +
  //     startTime +
  //     '/' +
  //     endTime +
  //     '/' +
  //     timeZone +
  //     '?Key=' +
  //     key +
  //     '&Value=' +
  //     value

  //   return axios
  //     .get(url, { headers: setHeaders() })
  //     .then((response) => {
  //       const totalConsentRecord = response.data
  //       return totalConsentRecord
  //     })
  //     .catch((error) => {
  //       if (error.response && error.response.status === 401) {
  //       }
  //       return null
  //     })
  // },
  fetchTotalActivityReport(
    { commit, dispatch, getters },
    { guidRecord, startTime, endTime, timeZone, key, value }
  ) {
    var url =
      appConfig.reportApiUri +
      'consumercreditactivityreport/getconsumeractivityreporttotalrecords/' +
      guidRecord +
      '/' +
      startTime +
      '/' +
      endTime +
      '/' +
      timeZone +
      '?Key=' +
      key +
      '&Value=' +
      value

    return axios
      .get(url, { headers: setHeaders() })
      .then((response) => {
        const totalActivityRecord = response.data
        return totalActivityRecord
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
        }
        return null
      })
  },

  fetchActivityReport(
    { commit, dispatch, getters },
    {
      guidRecord,
      startTime,
      endTime,
      timeZone,
      pageSize,
      pageNumber,
      key,
      value,
      sortBy,
      sortDirection,
    } = {}
  ) {
    var url =
      appConfig.reportApiUri +
      'consumercreditactivityreport/getconsumeractivityreport/' +
      guidRecord +
      '/' +
      startTime +
      '/' +
      endTime +
      '/' +
      timeZone +
      '?PageSize=' +
      pageSize +
      '&PageNumber=' +
      pageNumber +
      '&Key=' +
      key +
      '&Value=' +
      value +
      `&SortBy=${sortBy}&SortDirection=${sortDirection}`

    return axios
      .get(url, {
        headers: setHeaders(),
      })
      .then((response) => {
        const activityReport = response.data
        commit('SET_ACTIVITYREPORT', activityReport)

        return activityReport
      })
      .catch((error) => {
        if (error.Response && error.Response.status === 401) {
          commit('SET_ACTIVITYREPORT', null)
        }
        return null
      })
  },
  fetchOrderSummaryDetails({ commit }, { orderId, productId } = {}) {
    var url = `${appConfig.apiEndPoint}${
      endpoint.bcrApiPath.getordersummary
    }?orderId=${orderId}&productId=${productId}`

    return axios
      .get(url, { headers: setHeaders() })
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.Response && error.Response.status === 401) {
        }
        return null
      })
  },

  fetchCCRSummaryData({ commit }, { orderId } = {}) {
    var url = `${appConfig.apiEndPoint}${
      endpoint.ccrLobApiPath.getordersummaryccr
    }/${orderId}`

    return axios
      .get(url, { headers: setHeaders() })
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.Response && error.Response.status === 401) {
        }
        return null
      })
  },
  fetchPendingReport({ commit }, { orderId } = {}) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${
          endpoint.bcrApiPath.pendingfloodreport
        }?orderId=${orderId}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  fetchPendingForFlood({ commit }, orderId) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${
          endpoint.bcrApiPath.pendingFlood
        }?orderId=${orderId}`,
        {},
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  getInvoiceByOrderId({ commit }, orderId) {
    var url = `${appConfig.apiEndPoint}${
      endpoint.reportApiPath.getInvoiceByOrderId
    }?orderid=${orderId}`
    return axios
      .get(url, { responseType: 'arraybuffer' }, { headers: setHeaders() })
      .then((response) => {
        let reportName = 'Invoice_' + orderId
        if (window.navigator && window.navigator.msSaveBlob) {
          var blob1 = new Blob([response.data], { type: 'application/pdf' })
          window.navigator.msSaveBlob(blob1, reportName)
        } else {
          let blob = new Blob([response.data], { type: 'application/pdf' })
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = reportName
          link.click()
        }
      })
      .catch((error) => {
        return error
      })
  },
  fetchInvoiceReport({ commit }, orderId) {
    var url = `${appConfig.apiEndPoint}${
      endpoint.bcrApiPath.invoicereport
    }?orderId=${orderId}`

    return axios
      .get(url, { headers: setHeaders() })
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.Response && error.Response.status === 401) {
        }
        return null
      })
  },

  updateDiscount({ commit }, { orderId, discount }) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${
          endpoint.bcrApiPath.updateDiscount
        }?orderId=${orderId}&billingDiscount=${discount}`,
        {},
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  updateCurrentPage({ commit }, pageNumber) {
    commit('SET_CURRENT_PAGE', pageNumber)
  },

  updateReports({ commit }, reports) {
    if (reports === null) reports = []
    commit('SET_REPORTS', reports)
  },

  updateSelectedRow({ commit }, row) {
    commit('SET_SELECTED_ROW', row)
  },
}
function setHeaders() {
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${store.state.auth.currentUser.access_token}`,
  }
}
function setDefaultAuthHeaders(state) {
  axios.defaults.headers.get['Pragma'] = 'no-cache'
  axios.defaults.headers.get['Cache-Control'] = 'no-cache, no-store'
  axios.defaults.headers.common.Authorization = state.currentUser
    ? state.currentUser.access_token
    : ''
}
